import clsx from 'clsx'
import times from 'lodash/times'
import React, { FC } from 'react'

import { useTranslation } from '@Globals/Translations'

import styles from './StarRating.module.scss'

interface StarRatingProps {
  className?: string
  openReviews?: () => void
  rating: number
  ratingConcise?: boolean
  ratingCount?: number
}

export const StarRating: FC<StarRatingProps> = ({
  className,
  openReviews,
  rating,
  ratingConcise = false,
  ratingCount,
}: StarRatingProps) => {
  const { t } = useTranslation()
  if (!rating) { return null }

  const content = (
    <>
      {times(5, (count) => {
        const current = rating - count

        const width = `${Math.min(100, current * 100) - 18}%`

        return (
          <svg key={`rating-${current}`} className={styles.star} version="1.1" viewBox="0 0 12.1 11.5" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
              <clipPath id="star-clippath">
                <path d="M9.8,11.5l-3.7-1.9-3.7,1.9.7-4.2L0,4.4l4.2-.6,1.9-3.8,1.9,3.8,4.2.6-3,3,.7,4.2Z" />
              </clipPath>
            </defs>
            <g className={styles.starForm}>
              <rect height="11.5" width={width} />
            </g>
            <path d={`
            M9.8,11.5l-3.7-1.9-3.7,1.9.7-4.2L0,4.4l4.2-.6,1.9-3.8,1.9,3.8,4.2.6-3,3,.7,4.2Z
            M2.1,5.1l2,1.9-.4,2.7,2.4-1.3,2.4,1.3-.4-2.7,2-1.9-2.7-.4-1.2-2.5-1.2,2.5-2.7.4Z`}
            />
          </svg>
        )
      })}

      <span className={styles.ratingValue}>{rating.toFixed(1)}</span>
      {ratingCount && (
        <span className={styles.ratingCount}>
          {ratingConcise ? `(${ratingCount})` : `(${ratingCount} ${t('products:PP_REVIEWS_SECTION_TITLE')})`}
        </span>
      )}
    </>
  )

  if (openReviews) {
    return (
      <button className={clsx(className, styles.rating)} onClick={openReviews} type="button">
        {content}
      </button>
    )
  }
  return <div className={clsx(className, styles.rating)}>{content}</div>
}
